import React from "react";
import format from "date-fns/format";

import { SuppressionItemInfoView } from "@tiny/api";
import { Grid, ListItemCell, ListItemRow } from "@tiny/components";

interface DeleteSuppressionDetailsRowProps {
  item: SuppressionItemInfoView;
}

const DATE_FORMAT = "d MMM, yy - h:mm aa";

function DeleteSuppressionDetailsRow({
  item,
}: DeleteSuppressionDetailsRowProps) {
  const subText = React.useMemo(() => {
    if (!item?.createdAt) {
      return "";
    }
    const formatedDate = format(new Date(item?.createdAt), DATE_FORMAT);
    return `Created: ${formatedDate}`;
  }, [item?.createdAt]);

  return (
    <ListItemRow>
      <Grid item xs={8}>
        <ListItemCell size="body2" subText={subText} textColor="primary">
          {item.value}
        </ListItemCell>
      </Grid>
    </ListItemRow>
  );
}

export default DeleteSuppressionDetailsRow;
